export default {
  setLanguage: (state, language) => {
    state.language = language
  },
  setApiQuery: (state, o) => {
    state.api.push(o)
    if (state.api.length > 10) state.api.shift()
  }
}
